/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { Divider } from '../UNSAFE_Divider';
import { MenuDividerRedwoodTheme } from './themes/redwood/MenuDividerTheme';

export function MenuDivider() {
  const { classes } = useComponentTheme(MenuDividerRedwoodTheme);

  return (
    <div class={classes}>
      <Divider />
    </div>
  );
}
